import styled from 'styled-components';
export const LeftContainer = styled.div`
  order: 1;
  background-color: #f0f0f0;
  height: 100vh;
  .LeftContainer-margin {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 768px) {
    }
  }
  .span-login {
    font-size: 18px;
    color: black;
    font-weight: bold;
    margin-top: 11%;
    margin-bottom: 20px;
    font-family: 'Montserrat', sans-serif;
  }

  @media screen and (max-width: 768px) {
    .span-login {
      font-size: 18px;
      color: black;
      font-weight: bold;
      margin-top: 5%;
      margin-bottom: 20px;
      font-family: 'Montserrat', sans-serif;
    }
  }
`;

export const ImgTools = styled.img`
  width: 60%;
  margin-top: 70px;
  @media screen and (max-width: 768px) {
    margin-top: 50px;
    width: 30%;
  }
`;
export const ImgNotbook = styled.img`
  margin-top: 15px;
  width: 105%;
  @media screen and (max-width: 768px) {
    width: 54%;
    margin-left: 120px;
  }
`;

export const ContainerRight = styled.div`
  order: 2;
  background-color: #42b4e5;

  height: 100vh;

  .ContainerRight-margin {
    padding: 38px;
  }
  .text-one {
    margin-top: 50px;
    color: white;
    font-size: 25px;
    font-weight: bold;
    text-align: center;
    font-family: 'Montserrat', sans-serif;
  }
  .text-two {
    margin-left: 28%;
    margin-top: 4%;
    margin-bottom: 4%;
    padding-right: 30px;
    font-size: 15px;
    color: white;
    font-family: 'Montserrat', sans-serif;
  }

  @media screen and (max-width: 768px) {
    .ContainerRight-margin {
      padding: 10px;
    }
    .text-one {
      margin-top: 0px;
      color: white;
      font-size: 30px;
      font-weight: bold;
      text-align: center;
      font-family: 'Montserrat', sans-serif;
    }
    .text-two {
      margin-left: 25%;
      margin-top: 2%;
      margin-bottom: 4%;
      font-size: 18px;
      color: white;
      font-family: 'Montserrat', sans-serif;
      width: 55%;
    }
  }
`;
